import styled from "styled-components";
import { getCornerRadius } from "@swiggy-private/dls-web-common/dist/components/themes/CornerRadiusMapping/mapping";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { ITheme } from "@swiggy-private/dls-web-common/dist/components/types";

export const Footer = styled.div(({ theme }) => ({
    marginTop: theme.spacing.empty,
    display: "flex",
    alignItems: "center",
}));

export const FooterFirst = styled.button(({ theme }) => ({
    width: "40%",
    background: "transparent",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
    borderRadius: `${getCornerRadius(theme, "xxSmall")} 0 0 ${getCornerRadius(theme, "xxSmall")}`,
    outline: "none",
}));

export const ViewBillText = styled(Text)(({ theme }) => ({
    marginToop: theme.spacing.xxxSmall,
}));

const baseButtonStyles = ({ theme, isPopCart }: { theme: ITheme; isPopCart?: boolean }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "60%",
    height: "52px",
    background: theme.colors[theme.colorMode].special_positive,
    border: "1px solid transparent",
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.12)",
    borderRadius: getCornerRadius(theme, "small"),
    outline: "none",
    "&:disabled": {
        opacity: 0.8,
    },

    ...(isPopCart && {
        background: "#CAFE33",
        border: `1px solid ${theme.colors[theme.colorMode].text_Highest_Emphasis}`,
    }),
});

export const MakePaymentButton = styled.div<{ isPopCart?: boolean }>(baseButtonStyles);

export const SelectDeliverySlotButton = styled.button<{ isPopCart?: boolean }>(baseButtonStyles);
